import React,{useState , useEffect} from 'react'

import { useNavigate } from "react-router-dom";

const BMI = () => {

    const[weight,setWeight]=useState(0);
    const[height,setHeight]=useState(0);
    const[error , setErr] = useState(true);
    const navigate=useNavigate();

useEffect(() => {
    if(height<0  || weight<0){
        setErr(false);
    }else{
        setErr(true)
    }
}, [weight , height])



 const BmiCalc=(e)=>{
    e.preventDefault();
    
    if( (!height||!weight)){
        alert("please enter valid details")
    }
    else if(height<=0 || weight<=0){
        alert("Height and Weight must be positive")
    }
    else{
        let bmi=(weight/(height*height)*10000)

        if(bmi<12){
         navigate("/exunhealthy",{state:{bmi:bmi}})

        }
        else if(bmi>=12&&bmi<18.5){
            navigate("/underweight",{state:{bmi:bmi}})

          
        }
        else if(bmi>=18.5 && bmi<25){
            navigate("/healthy",{state:{bmi:bmi}})
        }
       else if(bmi>=25 && bmi<39){
               navigate("/overweight",{state:{bmi:bmi}})
   
        }
        else{
            navigate("/obessed",{state:{bmi:bmi}})
        }
    }
 }


 return (
 <div className='appp' >

    <div className='containerr'>
     <h2>BMI Calculator</h2>
     <form onSubmit={BmiCalc}>
     <div>
        <label>Weight(kg):</label>
        <input type="number"  placeholder="Enter your Weight" value={weight}
        onChange={(e)=>setWeight(e.target.value)} />
     </div>
     <div>
        <label>Height(cm):</label>
        <input type="number"  placeholder="Enter your Height" value={height}
        onChange={(e)=>setHeight(e.target.value)}/>
     </div>
     {error===false ? <p style={{color:'red'}}>Input must be positive</p>:<></>}

     <div>
        <button className='butn' type="submit" >Save</button>
     </div>
        </form>
    </div>
 </div>
 )
}

export default BMI;